export type DropdownOption = { label: string; value: string };

export type BenefitLogStatus = string;

export type BenefitLogFile = {
  id: string;
  name: string;
  sizeLabel: string;
  uploadDate: string;
  uploadedBy: string;
  filePath?: string;
  mediaId?: number;
  file?: File;
  isExisting?: boolean;
};

export type BenefitLogHistoryRow = {
  id: string;
  benefit: string;
  category: string;
  plannedDate: string;
  deliveredDate: string;
  status: BenefitLogStatus;
  hidOwner: string;
  partnerOwner: string;
  comment: string;
  files: BenefitLogFile[];
  hasCommentsOrFiles: boolean;
};

export const HISTORY_STATUS_OPTIONS: DropdownOption[] = [
  { label: "Delivered", value: "Delivered" },
  { label: "On hold", value: "On hold" },
  { label: "Ongoing", value: "Ongoing" },
];

export const CREATE_STATUS_OPTIONS: DropdownOption[] = [
  { label: "Ongoing", value: "Ongoing" },
  { label: "Delivered", value: "Delivered" },
  { label: "On hold", value: "On hold" },
];
